var XPortal = XPortal || {};
XPortal.ExTextEditor = (function () {
    var self = {
        ControlSelector: ".form-extext-input",
        Init: function (selector) {
            var container = $(selector ? selector : ".detail-page");
            container.find(XPortal.ExTextEditor.ControlSelector).each(function (i, element) {
                XPortal.ExTextEditor.initFor($(element), XPortal.Store.getModelName(container[0].id));
            });
        },
        initFor: function (el, modelName) {
            const sttgs = XPortal.Main.GetSettingsFor(el);
            sttgs.mask = el.attr("data-metadata-mask");
            sttgs.ishtml = el.attr("data-metadata-ishtml") == "1";
            sttgs.ismline = el.attr("data-metadata-ismline");
            sttgs.tools = sttgs.editable ? self.defaultTools : self.readOnlyDefaultTools;
            sttgs.change = sttgs.keyup;
            sttgs.past = sttgs.keyup;
            sttgs.value = sttgs.value ? sttgs.value : el.val();
            var xinterval = 0;
            sttgs.keyup = function () {
                clearTimeout(xinterval);
                xinterval = setTimeout(function () {
                    el.trigger("change");
                }, 250);
            };

            var isDark = $('body').hasClass('theme-dark');

            var pathToStyle = isDark ? "/content/css/dist/texteditorDark.css" : "/content/css/dist/texteditor.css"

            sttgs.stylesheets = [
                pathToStyle
            ];
            if (sttgs.ishtml) {
                var disabled = sttgs.editable ? '' : 'disabled';

                el.wrap(`<div class="kendoo-html-editor form-control p-0 ${disabled}"></div>`);
                el.kendoEditor(sttgs);
                var keditor = el.data("kendoEditor");
                if (!sttgs.editable) {
                    var ebody = $(keditor.body);
                    var bhtmlelements = [el, ebody,];
                    el.closest(".kendoo-html-editor").find("table, th, td, iframe").each(function (ixel, xel) { bhtmlelements.push(xel); });
                    $.each(bhtmlelements, function (ixel, xel) {
                        $(xel).attr("style", `${$(xel).attr("style") || ""};background:transparent!important;`);
                    });
                    ebody.removeAttr("contenteditable").find("a").on("click.readonly", false);
                }
                var changehandler = function (e) {
                    //view html button change issue- it doesn't trigger change in main/linked control
                    el.chageEventIndexId = setTimeout(function () {
                        el.trigger("change");
                    })
                }

                const editorHeight = parseInt(el.attr("data-metadata-height"), 10);
                if (editorHeight > 0) {
                    const $editor = $(el).closest(".k-editor");
                    const toolbarHeight = $editor.find(".k-editor-toolbar").outerHeight() || 0;
                    el.closest(".kendoo-html-editor").find("iframe").css("height", (editorHeight - toolbarHeight) + "px");
                }
                keditor.unbind("change", changehandler);
                keditor.bind("change", changehandler);
            }
            else if (sttgs.mask) self.initMask(el, sttgs);
            el.off("change");
            el.off("command");
            el.on("change", function () {
                clearTimeout(el.chageEventIndexId);
                var xvalue = getElementValue(el, sttgs);
                XPortal.DefaultEditor.SetModification(el, xvalue);
                XPortal.Store.FieldEvent(el, xvalue, modelName, sttgs);
            });

            if (el) {
                var picker = el.data("kendoMaskedTextBox");
                $((picker ? picker.element : null) || el).attr("data-skip", "");
            }

            if (sttgs.fieldname && modelName) {
                XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: el },
                    (value) => {
                        var cval = getElementValue(el, sttgs);
                        if (XPortal.DefaultEditor.IsModified(el, cval)) return;
                        setElementValue(el, sttgs, value);
                    },
                    (value) => getElementValue(el, sttgs, false)
                );
            }

        },
        initMask: function (el, o) {
            o.maskOpt = { rules: {}, mask: o.mask };
            var rxp = new RegExp("\{r\:([^}]*)\}");
            var erls = [{ n: '!' }, { n: '@' }, { n: '$' }, { n: '%' }, { n: '|' }, { n: '`' }];
            var k = 0;
            var mr = false;
            var initMaskRule = function (ik) {
                var ikrexp = erls[ik].r;
                return function (c) {
                    return ikrexp.exec(c);
                };
            };
            while (k < erls.length && (mr = rxp.exec(o.mask)) && mr.length > 1) {
                o.mask = o.mask.split(mr[0]).join(erls[k].n);
                erls[k].r = new RegExp(mr[1]);
                o.maskOpt.rules[erls[k].n] = initMaskRule(k);
                k++;
            };
            o.maskOpt.mask = o.mask;
            el.kendoMaskedTextBox(o.maskOpt);
        }
    };
    self.defaultTools = [
        "bold",
        "italic",
        "underline",
        //"strikethrough",
        "justifyLeft",
        "justifyCenter",
        "justifyRight",
        //"justifyFull",
        "insertUnorderedList",
        "insertOrderedList",
        //"indent",
        //"outdent",
        "createLink",
        "unlink",
        "insertImage",
        //"insertFile",
        "subscript",
        "superscript",
        "tableWizard",
        "createTable",
        "addRowAbove",
        "addRowBelow",
        "addColumnLeft",
        "addColumnRight",
        "deleteRow",
        "deleteColumn",
        "viewHtml",
        //"formatting",
        "cleanFormatting"
        //"fontName",
        //"fontSize",
        //"foreColor",
        //"backColor",
        //"print"
    ];
    self.readOnlyDefaultTools = [];
    function getElementValue(el, sttgs, defValue) {
        if (!el) return defValue;
        var r =
            sttgs.ishtml ? el.data("kendoEditor").value() :
                sttgs.mask ? el.data("kendoMaskedTextBox").value() :
                    el.val()
        return r;
    }
    function setElementValue(el, sttgs, valueToSet) {
        XPortal.DefaultEditor.ClearModification(el);
        el.val(valueToSet);
        var editor = el.data("kendoEditor");
        editor = editor || el.data("kendoMaskedTextBox");
        if (editor) editor.value(valueToSet);
        if (el.closest(".detail-page.d-mode-viewonly").length && sttgs.ishtml && editor) {
            var ifr = el.closest(".kendoo-html-editor").find("iframe")[0];
            if (ifr) {
                try {
                    var innerDoc = ifr.contentDocument || ifr.contentWindow.document;
                    var newHeight = innerDoc.body.scrollHeight;
                    ifr.style.height = (newHeight > 0 ? newHeight : 20) + "px";
                } catch (e) { }
            }
        }
    }
    return self;
}());
